<nav id="footer" aria-label="Primary">
  <button
    type="button"
    class="footer-icon-container"
    *ngIf="isIOS && (backCoordinator.canGoBack$ | async)"
    (click)="back()"
  >
    <span class="footer-icon">
      <img
        [src]="backIconData.iconSrc | safeUrl"
        alt=""
        (error)="onImageError()"
      />
    </span>
    <span class="footer-icon-label">{{ backIconData.name }}</span>
  </button>
  <button
    type="button"
    class="footer-icon-container"
    *ngFor="let fi of homeIconData.footerIcons"
    [class.is-active]="isCurrentRouteHome()"
    [attr.aria-current]="isCurrentRouteHome() ? 'page' : null"
    (click)="navigateToFeature(homeIconData.defaultPath, null)"
  >
    <span class="footer-icon">
      <img
        [src]="(isCurrentRouteHome() ? fi.negIconSrc : fi.iconSrc) | safeUrl"
        alt=""
        (error)="onImageError()"
      />
    </span>
    <span class="footer-icon-label">{{ fi.name }}</span>
  </button>
  <ng-container *ngIf="featureBaseUrl">
    <button
      type="button"
      class="footer-icon-container"
      *ngFor="let fi of footerIcons"
      [class.is-active]="doesCurrentRouteMatch(fi.path)"
      [attr.aria-current]="doesCurrentRouteMatch(fi.path) ? 'page' : null"
      (click)="navigateToFeature(defaultPath, fi.path)"
    >
      <span class="footer-icon">
        <img
          *ngIf="
            doesCurrentRouteMatch(fi.path)
              ? getNegIcon(fi)
              : getIcon(fi) as iconSrc
          "
          [src]="iconSrc | safeUrl"
          alt=""
          (error)="onImageError()"
        />
      </span>
      <span class="footer-icon-label">{{ fi.name }}</span>
    </button>
  </ng-container>
</nav>
